<template>
  <div class="project-ind">
    <div class="project-ind-header">
      <SelectCdjProjectHeader @onHeader="onHeader"></SelectCdjProjectHeader>
    </div>
    <div class="project-ind-body">
      <el-table :data="pageData.data" v-loading="loading" border height="calc(100vh - 300px)">
<!--        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>-->
        <el-table-column prop="project_name" label="项目" width="200" align="center" fixed></el-table-column>
        <el-table-column prop="area_name" label="区域" width="120" align="center" fixed></el-table-column>
        <el-table-column prop="all_count" label="业户数" align="center" width="150px"></el-table-column>
        <el-table-column prop="visit_frequency" label="拜访频次" align="center" width="150px">
          <template slot-scope="scope">
            <el-select size="mini" placeholder="选择频次" clearable v-model="scope.row.visit_frequency">
              <el-option label="拜访1次" :value="12"></el-option>
              <el-option label="拜访2次" :value="6"></el-option>
              <el-option label="拜访3次" :value="4"></el-option>
              <el-option label="拜访4次" :value="3"></el-option>
              <el-option label="拜访6次" :value="2"></el-option>
              <el-option label="拜访12次" :value="1"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="visit_count_min" label="每月拜访基准值" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.visit_count_min"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="visit_count" label="每月拜访目标值" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.visit_count"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="owner_repair_count" label="业主报修基准值" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.owner_repair_count"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="owner_repair_count_target" label="业主报修目标值" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.owner_repair_count_target"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="butler_repair_count" label="物业报修基准值" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.butler_repair_count"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="butler_urge_count" label="管家主任每日催费户数" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.butler_urge_count"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="manager_urge_count" label="项目经理每日催费户数" align="center" width="150px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.manager_urge_count"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="center" width="180px">
          <template slot-scope="scope">
            <el-input size="mini" v-model="scope.row.remark"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="updateCell(scope.row)">保存</el-button>
            <el-button size="mini" type="primary" @click="initProject(scope.row)">初始化</el-button>
<!--            <el-button size="mini" type="primary">日志</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="project-ind-footer">
      <el-pagination
        @current-change="pageChange"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        layout="total, prev, pager, next"
        :total="pageData.total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import SelectCdjProjectHeader from "./components/common/SelectCdjProjectHeader";
import ButlerHttp from "./common/ButlerHttp";
import {CommonHelp} from "./common/CommonHelp";
export default {
  name: "ProjectIndicators",
  components: {SelectCdjProjectHeader},
  data() {
    return {
      where: {},
      loading: false,
      pageData:{
        current_page: 1,
        per_page: 20,
        data:[],
        total:0
      },
    }
  },
  methods:{
    getList(){
      const that=this;
      that.loading=true;
      ButlerHttp.post("ProjectArea/index?page="+that.pageData.current_page+"&per_page="+that.pageData.per_page,that.where,ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.current_page = i;
      CommonHelp.debounce(()=>{
        that.getList()
      },500,that);

    },
    updateCell(row) {
      const that=this;
      ButlerHttp.post("ProjectArea/save",JSON.parse(JSON.stringify(row)),ret=>{
        if(ret.code){
          that.$message.success("保存成功");
          that.getList();
        }else {
          that.$message.error(ret.msg);
        }
      });
    },
    initProject(row){
      const that=this;
      ButlerHttp.post("ProjectArea/initProject",JSON.parse(JSON.stringify(row)),ret=>{
        if(ret.code){
          that.$message.success("校正成功");
          that.getList();
        }else {
          that.$message.error(ret.msg);
        }
      });
    },
    onHeader(data){
      const that=this;
      that.where.project_id=data.project_name;
      that.where.area_id=data.area_id;
      that.where.project_ids=data.project_ids;
      that.pageData.current_page=1;
      that.pageChange(1)
    }
  }
}
</script>

<style lang="scss" scoped>
.project-ind{
  padding: 20px;
  width: 100%;

  .project-ind-header{

  }
  .project-ind-footer{
    margin-top: 10px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/ProjectIndicators.vue